const validateNumberInterval = (num='',minMax=[1,5])=>{
  num=num+'';
  if(num === '') {
    return num;
  }


  num=parseInt(num.replace(/[^0-9]/g,''));
  if(isNaN(num)) {
    return '';
  }
  // const numLimits=[1,5];
  const numLimits=minMax;
  if(num < numLimits[0]) {
    num=numLimits[0];
  } else if(num > numLimits[1]) {
    num=numLimits[1];
  }
  return num;
}


const parseOrder = (order,maxLength)=>{
  if(order < 1) order=1;
  if(order > maxLength) order=maxLength;
  return order;
}


// to eventually filter the template JSON to remove some unwanted data
const filterTemplateJSON=(array)=>{
  const ret=array.filter(elem=>!elem.mainTitle);
  return ret;
}

// format to US default
const fmtNum=(num,sep=',')=>{
  num=parseInt(num)+'';
  const fmt=num.split('').reverse().join('').replace(/([0-9]{3})/g,'$1'+sep).split('')
  .reverse().join('').replace(/^,/,'');
  return fmt;
}


const fmtNumOrd=(num='')=>{
  num=num+'';
  const lastNum=+num.substring(num.length-1);
  let ordStr='th';
  if(lastNum === 1) {
    ordStr='st';
  } else if(lastNum === 2) {
    ordStr='nd'
  } else if(lastNum === 3) {
    ordStr='td';
  }

  return num+ordStr;
}


export {
  validateNumberInterval,
  parseOrder,
  filterTemplateJSON,
  fmtNum,
  fmtNumOrd
}